import { api, ReactQueryOptions, RouterInputs } from '@api'
import { staleTimeIndex } from '@specs/constants'
import { useSession } from '@shared/hooks/useSession'

type getCollectionEarningsCountOptions = ReactQueryOptions['ToyManager']['getCollectionEarningsCount']
type getCollectionEarningsCountInput = RouterInputs['ToyManager']['getCollectionEarningsCount']

export const useGetCollectionEarningsCount = (input: getCollectionEarningsCountInput, options?: getCollectionEarningsCountOptions) => {
    const { status } = useSession()

    return api.ToyManager.getCollectionEarningsCount.useQuery(input, {
        ...options,
        queryKey: ['ToyManager.getCollectionEarningsCount', input],
        staleTime: 5 * 60 * 1000 * staleTimeIndex, // 5 mins
        enabled: status === 'authenticated' && options?.enabled,
    })
}
